/**
 * Reads `name`, `message` and `stack` from a caught value, which is not guaranteed to be an Error.
 */
export function errorDetails(error: unknown): {
  name: string | undefined
  message: string | undefined
  stack: string | undefined
} {
  if (typeof error !== 'object' || error === null) {
    return { name: undefined, message: undefined, stack: undefined }
  }
  return {
    name: 'name' in error && typeof error.name === 'string' ? error.name : undefined,
    message: 'message' in error && typeof error.message === 'string' ? error.message : undefined,
    stack: 'stack' in error && typeof error.stack === 'string' ? error.stack : undefined,
  }
}
